import { Box, Button } from '@mui/material'
import { BackspaceOutlined } from '@mui/icons-material'

export const KEYPAD_BACKSPACE = 'backspace'

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', KEYPAD_BACKSPACE]

function NumericKeypad({
  onKeyPress,
  disabled
}: {
  onKeyPress: (key: string) => void
  disabled?: boolean
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 1,
        maxWidth: '360px',
        mx: 'auto',
        my: 2
      }}
    >
      {KEYS.map((key) => (
        <Button
          key={key}
          type='button'
          variant='outlined'
          color='inherit'
          disabled={disabled}
          onClick={() => onKeyPress(key)}
          aria-label={key === KEYPAD_BACKSPACE ? 'Usuń ostatni znak' : key}
          sx={{ minHeight: '56px', fontSize: '1.25rem' }}
        >
          {key === KEYPAD_BACKSPACE ? <BackspaceOutlined /> : key}
        </Button>
      ))}
    </Box>
  )
}

export default NumericKeypad
